package com.eladfinish.bible.contest.screens.randomVerse.ui

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.domain.catalog.BookData
import com.eladfinish.bible.contest.screens.mikud.model.mikudItem
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarContentPadding
import com.eladfinish.bible.contest.ui.layout.WithAdaptiveGridColumns
import kotlinx.coroutines.launch

@Composable
fun BooksGridLayout(
    items: List<Pair<BookData, Boolean>>,
    onMikudClick: () -> Unit,
    isCorrect: (String) -> Boolean,
    onBookClick: (String) -> Unit,
) {
    WithAdaptiveGridColumns(
        narrowColumns = 4,
        wideColumns = 5,
    ) { columnsCount ->
        val listState = rememberLazyGridState()
        val coroutineScope = rememberCoroutineScope()
        LazyVerticalGrid(
            modifier = Modifier
                .fillMaxWidth()
                .mouseVerticalScrollbar(listState),
            columns = GridCells.Fixed(count = columnsCount),
            contentPadding = navigationBarContentPadding(horizontal = 8.dp, top = 8.dp, bottom = 8.dp),
            state = listState,
        ) {
            items.forEachIndexed { index, item ->
                val isMikud = index == 0
                item(key = item.first.english, span = { GridItemSpan(currentLineSpan = 1) }) {
                    val hebrewName = item.first.hebrew
                    BookWidget(
                        title = hebrewName,
                        isMikud = isMikud,
                        active = isMikud || item.second,
                        onClick = {
                            if (isMikud) {
                                onMikudClick()
                            } else {
                                if (isCorrect(hebrewName)) {
                                    coroutineScope.launch {
                                        listState.animateScrollToItem(0)
                                    }
                                }
                                onBookClick(hebrewName)
                            }
                        }
                    )
                }
            }
        }
    }
}

@Preview
@Composable
private fun BooksGridLayoutPreview() {
    val items = listOf(mikudItem) + BibleCatalog.books
    val enabledList = MutableList(items.size) { true }
    BooksGridLayout(
        items = items.zip(enabledList),
        onMikudClick = {},
        onBookClick = {},
        isCorrect = { true },
    )
}
